// src/pages/administrativo/ConfigDFeSearch.js
import React, { useEffect, useState, useRef } from 'react';

import { useConfigDFe } from '../../contexts/administrativo/ConfigDFeContext';  // Contexto de ConfigDFe
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import ModalTable from '../../components/modalForm/ModalTable';
import LazyLoading from '../../components/modalForm/LazyLoading';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const ConfigDFeSearch = ({ show, onHide, onSelectConfigDFe }) => {
    const { configDFeList } = useConfigDFe(); // Contexto de Configuração de DFe
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id'); // 'id' ou 'numeroCertificado'
    const [sortDirection, setSortDirection] = useState('asc'); // 'asc' ou 'desc'
     // Quantidade de itens por página

    const inputRef = useRef(null); // Referência para o input

    useEffect(() => {
        if (show) {
            setFilter('');

            if (inputRef.current) {
                inputRef.current.focus(); // Aplica o foco no input quando o modal abrir
            }
        }
    }, [show]);

    if (!show) return null;

    // Filtra as configurações de DFe pelo número do certificado
    const filteredConfigDFe = configDFeList.filter(config =>
        config.numeroCertificado.toLowerCase().includes(filter.toLowerCase())
    );

    // Ordena as configurações de DFe de acordo com o campo e direção selecionados
    const sortedConfigDFe = filteredConfigDFe.sort((a, b) => {
        if (sortField === 'id') {
            return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        } else if (sortField === 'numeroCertificado') {
            const certA = a.numeroCertificado.toLowerCase();
            const certB = b.numeroCertificado.toLowerCase();
            if (certA < certB) return sortDirection === 'asc' ? -1 : 1;
            if (certA > certB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        }
        return 0; // Retorno padrão
    });

    // Divide as configurações de DFe em páginas

    // Número total de páginas

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (configDFe) => {
        onSelectConfigDFe(configDFe);
        onHide();
    };

    return (
        <ModalContainer show={show} largura="600px" variant="busca" onHide={onHide}>

            <ModalHeader title="Buscar Configuração de DFe" onHide={onHide} />
            <ModalBody className="modal-body">
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por número do certificado..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading items={sortedConfigDFe} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable  containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('id')} style={{ fontWeight:'bold', background: 'none', border: 'none' }} type="button">
                                    Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="align-middle" scope="col" style={{ width: '50%' }} aria-sort={sortField === 'numeroCertificado' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('numeroCertificado')} style={{ fontWeight:'bold', background: 'none', border: 'none' }} type="button">
                                    Número do Certificado
                                    {sortField === 'numeroCertificado' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '20%' }}>Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map(configDFe => (
                            <tr key={configDFe.id} onDoubleClick={() => handleDoubleClick(configDFe)}>
                                <td className="text-end align-middle">{configDFe?.id}</td>
                                <td className="align-middle">{configDFe?.numeroCertificado}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton className="btn btn-outline-secondary btn-sm" onClick={() => onSelectConfigDFe(configDFe)} label={configDFe?.numeroCertificado} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter className="modal-footer">

                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>

        </ModalContainer>
    );
};

export default ConfigDFeSearch;
